import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class TokenRefreshService {
  private refreshPromise: Promise<boolean> | null = null;

  constructor(private readonly authService: AuthService) {}

  async refreshIfNeeded(): Promise<boolean> {
    if (this.refreshPromise !== null) {
      return this.refreshPromise;
    }

    this.refreshPromise = this.authService.refreshToken().finally(() => {
      this.refreshPromise = null;
    });

    return this.refreshPromise;
  }

  isRefreshing(): boolean {
    return this.refreshPromise !== null;
  }
}
